import { getNearbyBreak } from './xAxis';
import { DateTime } from 'luxon';
import { TimeSeriesDisableRange } from 'utils/timeseries/TimeSeriesDisableRange';

import { timeFormatConstants } from '@instinet-analytics/core-lib';
const { date, timeHours, timeMinutesNoMeridiem, toLowercaseMeridiem } =
    timeFormatConstants;

const xIntervalIsHourly = (xInterval: number) => xInterval === 60;

const formatDate = (format: string) => (d: Date) =>
    toLowercaseMeridiem(DateTime.fromJSDate(d).toFormat(format));

const formatDays = formatDate(date);

const formatHours = formatDate(timeHours);

const formatHoursAndMinutes = (d: Date) =>
    formatDate(d.getMinutes() === 0 ? timeHours : timeMinutesNoMeridiem)(d);

export const createDateTickFormatter =
    (
        timeBreaks: TimeSeriesDisableRange[],
        dayLabels: boolean,
        xInterval: number
    ) =>
    (d: Date): string => {
        const nearbyBreak = getNearbyBreak(d, timeBreaks);
        if (nearbyBreak && !nearbyBreak.isMultiDayBreak) {
            return '';
        }

        const formatter = dayLabels
            ? formatDays
            : xIntervalIsHourly(xInterval)
            ? formatHours
            : formatHoursAndMinutes;

        return formatter(
            nearbyBreak?.isMultiDayBreak ? new Date(nearbyBreak.to) : d
        );
    };
